import { Select } from "antd";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./DemoWindow.scss";
import {
  createDemoPlayerDebounced,
  disposeDemoPlayer,
} from "./DemoWindowHelpers";
import { SimpleLoader } from "../SimpleLoader";
import { DemoSdkExternalLink } from "./DemoSdkExternalLink";
import type { IProjectFetchData } from "@blings/blings-player/lib/src/SDK/sdk.api";
import { sharedSelectAllowClear } from "../antd-extensions/selectClearIcon";
import type { StudioScenePatch } from "../../stores/runPlayerCache";

export const DemoWindow = ({
  project,
  liveControlData,
  posterFrame,
  autoplay,
  openWin,
  height,
  selectedVideoPart,
  data,
  videoPartNames,
  draftScene,
}: {
  project: IProjectFetchData;
  videoPartNames: string[];
  liveControlData: any;
  posterFrame: number;
  autoplay: boolean;
  openWin: Function;
  height: number;
  selectedVideoPart: any;
  data: any;
  draftScene?: StudioScenePatch;
}) => {
  const [scenes, setScenes] =
    useState<string[]>(
      (selectedVideoPart && [selectedVideoPart.name]) ||
        (videoPartNames && [videoPartNames[0]])
    ) || [];
  const [loaderDisplay, setLoaderDisplay] = useState(true);

  useEffect(() => {
    createDemoPlayerDebounced(
      setLoaderDisplay,
      scenes,
      project,
      liveControlData,
      data,
      autoplay,
      posterFrame,
      draftScene
    );
    return disposeDemoPlayer;
  }, [scenes, draftScene]); // eslint-disable-line react-hooks/exhaustive-deps

  function closeNav(e: any) {
    if (!e.target.onclick) return false;
    e.stopPropagation();
    openWin(false);
  }

  // Use portal to render at document body level, avoiding stacking context issues
  return createPortal(
    <div id="DemoWin" className="overlay">
      {/* onClick={closeNav}> for Clicking on the window will close it*/}

      <div className="content">
        <span role="button" className="closebtn" onClick={closeNav}>
          &times;
        </span>
        <div className="demo-container-wrapper">
          <div id="demo-container"></div>
        </div>
        {loaderDisplay && (
          <div className="demo-loader-container">
            <SimpleLoader />
          </div>
        )}
      </div>
      <div className="ui-container">
        <div className="ui-in-Panel">
          <div className="add-scenes"> Add Scenes</div>
          <div className="ui-scenes">
            <Select
              id="demo-select"
              className="blings-select-controls"
              mode="multiple"
              allowClear={sharedSelectAllowClear}
              dropdownClassName="demo-select-dropdown"
              getPopupContainer={(triggerNode) =>
                triggerNode.parentElement || document.body
              }
              onChange={setScenes}
              value={scenes}
            >
              {videoPartNames.map((vp) => (
                <Select.Option key={vp} value={vp}>
                  {vp}
                </Select.Option>
              ))}
            </Select>
            {
              <DemoSdkExternalLink
                project={project}
                scenes={scenes}
                data={data}
              ></DemoSdkExternalLink>
            }
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
